<template>
    <div ref="playerRef">
    </div>
</template>

<script setup>
    import { ref, onMounted, defineEmits } from 'vue';
    import YouTubePlayer from 'youtube-player';

    const props = defineProps({
        videoId: String,
        autoplay: Boolean,
    });

    const emit = defineEmits(['on-player-loaded']);

    const playerRef = ref(null);
    let player = null;

    onMounted(() => {
        player = YouTubePlayer(playerRef.value, { host: 'https://www.youtube-nocookie.com' });
        if (props.autoplay) {
            player.loadVideoById(props.videoId);
        } else {
            player.cueVideoById(props.videoId);
        }
        player.on('ready', (event) => {
            emit('on-player-loaded', event.target);
        });
        player.on('stateChange', (event) => {
            if (event.data === 1) {
                emit('on-play');
            } else if(event.data === 0) {
                emit('on-ended');
            }
        });
    });

</script>